import { createSelector } from 'reselect';

import { CLIPPING } from 'constants/FeatureConstants';
import { ENTITY_TYPE } from 'modules/app/constants';
import { getByGuidelineId, getState as getParent } from 'modules/guidelines/selectors';
import { getRoot } from 'utils/selectors';

const getState = createSelector(getParent, state => state.ui.details);

export const getSelectedId = createSelector(getState, state => state.selectedId);

export const getSelectedGuideline = createSelector(getRoot, getSelectedId, (root, selectedId) =>
  (selectedId ? getByGuidelineId(root, selectedId) : undefined));

export const isLoading = createSelector(getState, state => state.loading);

export const hasError = createSelector(getState, state => state.error);

export const hasMediaWithClippingEnabled = createSelector(getSelectedGuideline, guideline => {
  const { optional = [], mandatory = [] } = guideline ?? {};
  return [...optional, ...mandatory].some(({ exampleMedia }) => exampleMedia?.transformations?.includes(CLIPPING) ?? false);
});

export const getWebSocketParams = createSelector(getSelectedGuideline, guideline =>
  (guideline ? { entityId: guideline.id, entityType: ENTITY_TYPE.GUIDELINE } : guideline));
